import { LayoutGrid } from "lucide-react";
import { useNavigate } from "react-router-dom";

/** Navigate back to the Apps launcher (`/`). */
export function AllAppsButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="btn btn-secondary btn-sm"
      title="All Apps"
      onClick={() => navigate("/apps")}
    >
      <LayoutGrid size={13} />
      All Apps
    </button>
  );
}
